import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { MAP_DEFAULT_ZOOM } from '../util/constants';
const useMapsStore = create(subscribeWithSelector((set) => ({
    lotListExpanded: true,
    setLotListExpanded: (expanded) => set(() => ({ lotListExpanded: expanded })),
    brand: '',
    setBrand: (brand) => set(() => ({ brand: brand })),
    communityId: '',
    setCommunityId: (communityId) => set(() => ({ communityId: communityId })),
    zoom: MAP_DEFAULT_ZOOM,
    setZoom: (zoom) => set(() => ({ zoom: zoom }))
})));
export const usePrintEventStore = create(subscribeWithSelector((set) => ({
    isPrintMapRendering: false,
    setIsPrintMapRendering: (isRendering) => set(() => ({ isPrintMapRendering: isRendering })),
    isPrintButtonLoading: false,
    setIsPrintButtonLoading: (isLoading) => set(() => ({ isPrintButtonLoading: isLoading }))
})));
export default useMapsStore;
